import cryptoUtils from "../utils/utils";

export default {
    // ! do any wallet validation here for FrontEnd and make sure to update the BackEnd wallet validation as well for this blockchain!

    isValidAddress(address) {
        return true;
    }
};